import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'supporter-action',
		path: '/p/:slug/supporter-action/start-a-recommended-petition',
		component: loadable(async () => import(/* webpackChunkName: "pages/supporter_action" */ './index'), {
			exportName: 'SupporterAction',
			fallback: Loading,
		}),
		frame: { header: true, footer: false },
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
